import * as sup from "superstruct";

import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import { createResponseStruct } from "@/modules/api/utils/jsonApiStructs";
import { groupsResourceStruct } from "@/modules/groups/api/resources/groupsResourceStruct";

import { getUnacknowledgedLevelsPath } from "../resources/unacknowledgedLevel/unacknowledgedLevelResourceConsts";
import { unacknowledgedLevelsResourceStruct } from "../resources/unacknowledgedLevel/unacknowledgedLevelResourceStructs";

export const getUnacknowledgedLevelsQuery = (
  jsonApi: JsonApiClient,
  { companyId }: { companyId: string }
) => {
  return jsonApi.getMany({
    path: getUnacknowledgedLevelsPath(companyId),
    responseStruct: getUnacknowledgedLevelsResponseStruct,
  });
};

const getUnacknowledgedLevelsResponseStruct = createResponseStruct({
  data: unacknowledgedLevelsResourceStruct,
  included: groupsResourceStruct,
});

export type GetUnacknowledgedLevelsResponse = sup.Infer<
  typeof getUnacknowledgedLevelsResponseStruct
>;
